// eslint-disable-next-line no-unused-vars
import { data } from 'autoprefixer';
import axios from 'axios';
import router from '../../../router';
import types from './mutations-types';

const actions = {
  async login({ commit, state }, obj) {
    if (!obj.email || !obj.password) {
      return {
        auth: false,
      };
    }

    const resp = await axios.post(
      `${process.env.API_ROOT}/login`,
      {
        email: obj.email,
        password: obj.password,
        country: obj.country,
        companyId: obj.companyId,
        selectedCompany: obj.selectedCompany,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      },
    );
    commit(types.SET_USER, {
      ...resp.data,
    });
    localStorage.setItem('_indecx', JSON.stringify(state.user));

    return {
      auth: true,
      companyId: resp.data.companyId,
      companyList: resp.data.companyList,
      token: resp.data.token,
      twoFactorCode: resp.data.twoFactorCode,
      typeUser: resp.data.permissions.type,
      // hasStrongPassword: resp.data.hasStrongPassword,
    };
  },
  async loginByEmail({ commit }, email) {
    axios.post(
      `${process.env.API_ROOT}/login-by-email`,
      {
        email,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      },
    );
  },
  async authentication({ commit, state }, obj) {
    axios
      .post(
        `${process.env.API_ROOT}/authentication`,
        {
          ...obj,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
          },
        },
      )
      .then((response) => {
        commit(types.SET_USER, response.data);
        localStorage.setItem('_indecx', JSON.stringify(state.user));
        router.push(`/dashboard/${response.data.companyId}`);
      })
      .catch();
  },
  async validateToken({ commit }, token) {
    const valid = await axios.post(
      `${process.env.API_ROOT}/validateToken`,
      {
        token,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'frontend-access-key': process.env.FRONTEND_ACCESS_KEY,
        },
      },
    );
    return valid.data;
  },
  async logout({ commit }, token) {
    axios
      .post(
        `${process.env.API_ROOT}/logout`,
        {},
        {
          headers: {
            'x-access-token': token,
            'Access-Control-Allow-Origin': '*',
          },
        },
      )
      .then(() => {
        localStorage.setItem(
          '_indecx',
          JSON.stringify({
            auth: false,
          }),
        );
        router.push('/');
      });
  },
  async validationProfile({ commit }, obj) {
    try {
      const res = await axios.post(
        `${process.env.API_ROOT}/validationProfile`,
        {},
        { headers: { 'x-access-token': obj.token } },
      );

      commit(types.SET_PROFILE, res.data);
    } catch (error) {
      window.console.log(error);
    }
  },
};
export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js